import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RenewalRoutingModule } from './renewal-routing.module';
import { RenewalComponent } from './renewal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RestrictionComponent } from './restriction/restriction.component';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PaymentModule } from 'src/app/shared/payment/payment.module';
import { LoaderModule } from '../loader/loader.module';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { RenewActiveComponent } from './renew-active/renew-active.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    RenewalComponent,
    RestrictionComponent,
    RenewActiveComponent,

  ],
  imports: [
    CommonModule,
    RenewalRoutingModule,
    SharedModule,
    CustomFlexLayoutModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    PaymentModule,
    LoaderModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule

  ], exports: [
    RenewalComponent,
    RestrictionComponent
  ]
})
export class RenewalModule { }
